import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CookieProvider } from "@/context/CookieContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Governance from "@/pages/Governance";
import Projects from "@/pages/Projects";
import InvestorRelations from "@/pages/InvestorRelations";
import Bambereaux from "@/pages/Bambereaux";
import AgroIndustrial from "@/pages/AgroIndustrial";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <CookieProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/governance" element={<Governance />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/investor-relations" element={<InvestorRelations />} />
              <Route path="/bambereaux" element={<Bambereaux />} />
              <Route path="/agro-industrial-platform" element={<AgroIndustrial />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid rgba(10,31,68,0.15)",
              fontFamily: "IBM Plex Sans, sans-serif",
              color: "#0A1F44",
            },
          }}
        />
      </CookieProvider>
    </div>
  );
}

export default App;
